import axios from "axios";
import { BASE_URL } from "../constants/common";
import { getLocalStorageData } from "../../utils/helpers/helpers";


const get = async (url) => {
  let AccessToken = getLocalStorageData("accessToken") || "";
  let Authorization = getLocalStorageData("authorizationToken")
    ? `${"Bearer " + getLocalStorageData("authorizationToken")}`
    : "";
  let reqHeaders = {
    UtcOffsetInSecond: 19800,
    AppVersion: 1,
    AccessToken,
    Authorization,
  };
  try {
    const response = await axios.get(`${BASE_URL}${url}`, {
      headers: reqHeaders,
    });
    return response.data;
  } catch (error) {
    console.error("Error get:", error.response.status);
    if (error.response.status === 401) {
      removeLocal();
    }
    throw error;
  }
};

const post = async (url, data) => {
  let AccessToken = getLocalStorageData("accessToken") || "";
  let Authorization = getLocalStorageData("authorizationToken")
    ? `${"Bearer " + getLocalStorageData("authorizationToken")}`
    : "";
  console.log("******* TOKEN ****", AccessToken, Authorization);
  let reqHeaders = {
    UtcOffsetInSecond: 19800,
    AppVersion: 1,
    AccessToken,
    Authorization,
  };

  try {
    const response = await axios.post(`${BASE_URL}${url}`, data, {
      headers: reqHeaders,
    });

    return response;
  } catch (error) {
    console.error("Error:", error);
    console.error("Error:POST", error.response.status);
    if (error.response.status === 401) {
      removeLocal();
    } else if (error.response.status === 498) {
      console.log("invalid token *****");
      removeLocal();
    }
    throw error;
  }
};
const postupload = async (url, data) => {
  let AccessToken = getLocalStorageData("accessToken") || "";
  let Authorization = getLocalStorageData("authorizationToken")
    ? `${"Bearer " + getLocalStorageData("authorizationToken")}`
    : "";

  let reqHeaders = {
    UtcOffsetInSecond: 19800,
    AppVersion: 1,
    AccessToken,
    Authorization,
  };

  try {
    const response = await axios.post(`${BASE_URL}${url}`, data, {
      headers: reqHeaders,
      responseType: "blob", // Set the response type here
    });

    return response;
  } catch (error) {
    console.error("Error:", error);
    console.error("Error:POST", error.response.status);
    if (error.response.status === 401) {
      removeLocal();
    } else if (error.response.status === 498) {
      console.log("invalid token *****");
      removeLocal();
    }
    throw error;
  }
};
const put = async (url, data, headers = {}) => {
  try {
    const response = await axios.put(`${BASE_URL}${url}`, data, { headers });
    return response;
  } catch (error) {
    console.error("Error:", error);
    console.error("Error:", error.response.status);
    if (error.response.status === 401) {
      removeLocal();
    }
    throw error;
  }
};

const patch = async (url, data, headers = {}) => {
  try {
    const response = await axios.patch(`${BASE_URL}${url}`, data, { headers });
    return response;
  } catch (error) {
    console.error("Error:", error);
    console.error("Error:", error.response.status);
    if (error.response.status === 401) {
      removeLocal();
    }
    throw error;
  }
};

const del = async (url, headers = {}) => {
  try {
    const response = await axios.delete(`${BASE_URL}${url}`, { headers });
    return response;
  } catch (error) {
    console.error("Error:", error);
    console.error("Error:", error.response.status);
    if (error.response.status === 401) {
      removeLocal();
    }
    throw error;
  }
};

const removeLocal = () => {
  localStorage.removeItem("authorizationToken");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("userId");
  localStorage.removeItem("loginTime");
};
export { get, post, put, patch, del, postupload };

// example of http request
// const data = await get('/someEndpoint');
// console.log('GET Data:', data);

// const postDataResponse = await post('/someEndpoint', { key: 'value' });
// console.log('POST Data:', postDataResponse);

// const putDataResponse = await put('/someEndpoint', { key: 'value' });
// console.log('PUT Data:', putDataResponse);

// const patchDataResponse = await patch('/someEndpoint', { key: 'value' });
// console.log('PATCH Data:', patchDataResponse);

// const deleteDataResponse = await del('/someEndpoint');
// console.log('DELETE Data:', deleteDataResponse);
